<template>
  <div @click="$router.push(to)" class="d-flex align-center mb-6 cursor-pointer">
    <v-btn icon outlined class="mr-2">
      <v-icon>
        mdi-arrow-left
      </v-icon>
    </v-btn>
    <span class="text-subtitle-1 font-weight-medium hover-underline">{{ $t("Back") }}</span>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object],
      default: () => ({ name: 'my-subscriptions' }),
    },
  },
};
</script>
